import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Reveal } from './Reveal';
export function Testimonials() {
  return;
}